import { fillString } from '@local_modules/generic/string-template.js'
import { generateRandomString } from '@local_modules/generic/text/generate-random-string/index.js'
import { setElementHtml } from '@local_modules/generic/dom/set-element-html.js'

import htmlTemplateIndex from './index.html'
import { showTableEntities } from './show-table.js'

import { checkPageRestriction } from '../../../../helpers/restrictions/check-page-restriction.js'
import { applyHtmlRestrictions } from '../../../../helpers/restrictions/apply-html-restrictions.js'
import { loadAllEntities } from './load.js'

/**
 *
 * @param {Object} params
 * @param {String} params.containerElementId
 * @param {Object} params.browserAppUser
 *
 * @returns
 */
export async function showAdminListEntities (params) {
  console.log('showAdminListEntities')

  const { containerElementId, browserAppUser } = params

  if (!checkPageRestriction({ browserAppUser, allowNoAccount: true })) return

  // Prepare the html
  let htmlIndex = htmlTemplateIndex

  htmlIndex = applyHtmlRestrictions(htmlIndex, { browserAppUser })
  const elementId = 'i' + generateRandomString()
  htmlIndex = fillString(htmlIndex, { elementId })

  // Inject in the page
  setElementHtml(containerElementId, htmlIndex)

  document.getElementById(containerElementId)?.classList.add('position-absolute')
  document.getElementById(containerElementId)?.classList.add('top-to-bottom')

  // Set page title
  document.title = ['All Entities'].join(' ')

  const entitiesResponse = await loadAllEntities()

  showTableEntities(entitiesResponse)
}
